import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Roots feature parameters */
export interface RootsParams {
  /** Reference to parent function element */
  of: string;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const ROOTS_DEFAULT_PARAMS: Omit<RootsParams, 'of'> = {};

/**
 * Default theme for roots feature.
 * Indigo colored points for x-intercepts.
 */
export const ROOTS_DEFAULTS: FeatureStyleNode = {
  point: { color: 'teal', fixed: true },
};
